import Vue from 'vue'
import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { domTitle, setDocumentTitle } from '@/utils/domUtil'
import { ACCESS_TOKEN, MENU_PARAM_LIST, OPERATOR, RECENT_ROUTES } from '@/store/mutation-types'
import { clearVue } from '@/utils/util'
import moment from 'moment'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'registerResult','PdaLogin','PdaIndex']// no redirect whitelist
let recentRoutes = Vue.ls.get(RECENT_ROUTES)
router.beforeEach((to, from, next) => {
  //获取路由参数  add by mcp 2020-1-20
  let menuParams = Vue.ls.get(MENU_PARAM_LIST)
  if (menuParams === undefined || menuParams === null || menuParams.length === 0) {
    menuParams = store.getters.menuParams || []
  }
  //console.log(menuParams,'menuParams')
  const pa = menuParams.filter(item => item.key === to.path)
  if (pa) {
    to.query.params = pa
  }
  NProgress.start() // start progress bar
  to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${to.meta.title} - ${domTitle}`))
  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    // if (to.path === '/user/login') {
    //   next({ path: '/warehouse/warehouse-select' })
    //   NProgress.done()
    // } else {
    if (store.getters.roles.length === 0) {
      //console.log(store.getters.operator,'store.getters.operator')
      //console.log(VueCookie.get('operator'),'VueCookie')
      const operator = Vue.ls.get(OPERATOR)
      store
        .dispatch('GetInfo', { operator })
        .then(res => {
          const roles = res.role.permissions
          if (roles === undefined || roles.length === 0) return
          if (to.path.indexOf('pda')===-1){
            store.dispatch('GenerateRoutes', { operator })
          }
          // 根据roles权限生成可访问的路由表
          // 动态添加可访问路由表
          router.addRoutes(store.getters.addRouters)
          const routes = store.getters.addRouters
          //console.log(store.getters.addRouters, 'addRouters')
          const redirect = decodeURIComponent(from.query.redirect || to.path)

          if (to.path === redirect) {
            // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            next({ ...to, replace: true })
          } else {
            next({ path: to.path })
            NProgress.done()

            // if (Vue.ls.get(WAREHOUSE)) {
            //   // 跳转到目的路由
            //   next({ path: redirect, query: { params: menuParams.find(item=>item.key===redirect)} })
            // } else {
            //   next({ path: '/warehouse/warehouse-select' })
            //   NProgress.done()
            // }
          }
        })
        .catch((error) => {
          clearVue()
          notification.error({
            message: '错误',
            description: ((error.response || {}).data || error.message || {}) + '请求用户信息失败，请重试'
          })
          store.dispatch('Logout').then(() => {
            next({ path: '/user/login', query: { redirect: to.fullPath } })
          })
        })
    } else {
      next()
    }

  } else {
    if (whiteList.includes(to.name)||to.path&&to.path.indexOf("pda")!==-1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
  //更新最近访问
  if (to.name !== 'recentView') {
    if (recentRoutes === undefined || recentRoutes === null) {
      recentRoutes = []
    }
    const idx = recentRoutes.findIndex(r => r.path === to.path)
    if (idx !== undefined && idx > 0) {
      recentRoutes.splice(idx, 1)
    }
    recentRoutes.push({
      timeFormat: moment().format('YYYY-MM-DD HH:mm:ss'),
      time: moment().unix(),
      name: to.name,
      path: to.path,
      title: to.meta.title
    }) //{time:moment().format('YYYY-MM-DD HH:mm:ss'),router:to}
    //recentRoutes = recentRoutes.sort(sortTime)
    Vue.ls.set(RECENT_ROUTES, recentRoutes)
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
